import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-quote-text q-ml-xs cursor-pointer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " | ", -1)

import SfxTooltip from "src/components/tooltip/SfxTooltip.vue"
import { TooltipData, TooltipPosition } from "src/util/types/components/sfxTooltip"
import { PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTrueCount',
  props: {
  trueTotal: {
    type: Number,
    required: true,
  },

  tooltipData: {
    type: Object as PropType<TooltipData>,
  },

  position: {
    type: String as PropType<TooltipPosition>,
    default: "bottom",
  },
},
  setup(__props) {

const props = __props

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, [
      _createElementVNode("b", null, _toDisplayString(props.trueTotal), 1),
      _createVNode(SfxTooltip, {
        position: props.position,
        data: props.tooltipData
      }, null, 8, ["position", "data"])
    ])
  ]))
}
}

})